import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import FlowGallery from "./gallery/flows/index.tsx";
import WorkflowGallery from "./gallery/workflows/index.tsx";
import WorkflowDetail from "./gallery/workflows/[workflowId]/index.tsx";
import FlowDetail from "./gallery/flows/[flowId]/index.tsx";


export default function Gallery() {
  return (
    <Routes>
      <Route path="/flows" element={<FlowGallery />} />
      <Route path="/flow/:flowId" element={<FlowDetail />} />
      <Route path="/workflows" element={<WorkflowGallery />} />
      <Route path="/workflow/:workflowId" element={<WorkflowDetail />} />
      <Route path="/" element={<Navigate to="/gallery/workflows" replace />} />
    </Routes>
  );
}
